import { screenResource } from '@/api'

const state = {
  loading: false,
  screens: []
}

const getters = {
  screens: (state) => {
    return state.screens
  }
}

const actions = {
  loadScreens ({ commit }) {
    commit('SET_LOADING', true)

    screenResource.all().then(res => {
      commit('SET_SCREENS', res.data.returnValue)
      commit('SET_LOADING', false)
    }).catch(err => {
      console.log(err)
    })
  },

  addScreen ({ commit }, screen) {
    screenResource.create(screen).then((res) => {
      commit('ADD_SCREEN', res.data.returnValue)
    })
  },

  removeScreen ({ commit }, screen) {
    screenResource.destroy(screen.screenId).then(() => {
      commit('REMOVE_SCREEN', screen)
    })
  },

  clearScreens ({ commit }) {
    commit('SET_SCREENS', [])
  }
}

const mutations = {
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_SCREENS (state, screens) {
    state.screens = screens
  },

  ADD_SCREEN (state, screen) {
    state.screens.push(screen)
  },

  REMOVE_SCREEN (state, screen) {
    let i = state.screens.map(item => item.screenId).indexOf(screen.screenId)
    state.screens.splice(i, 1)
  }
}

export default { namespaced: true, state, getters, actions, mutations }
